import { getCropper } from "~/fc/cropper";
import { getKeyByValue } from "~/fc/Helpers/FormatHelpers";

export default {
    data: () => ({
        lastOrientation: true,
        lastCrop_aspect_ratio: "free",
        tempSelection: {},
        lastDimention: false
    }),
    computed: {
        allSelectionFull() { return Object.assign({}, JSON.parse(JSON.stringify(this.$store.state.advancedSetting.userData))); },
        allSelection() { return this.allSelectionFull.allSelection.root; },
        aspectRatioComputed() { return this.allSelection[getKeyByValue(this.allSelectionFull.fieldNames, "crop_aspect_ratio")] },
        aspectRatio() { return this.$store.state.advancedSetting.cropAspectRatio },
        customDimension() { return this.allSelection["602a06a3e2679d0023d12188"] },
        cropRatioXID() { return this.$store.state.advancedSetting.cropSettingsIds['crop_ratio_x'] || '65824b8b00515d07a5ba696b' },
        cropRatioYID() { return this.$store.state.advancedSetting.cropSettingsIds['crop_ratio_y'] || '65824d7b00515d07a5ba69bb' },
        cropRatioX() { return this.allSelection[this.cropRatioXID] },
        cropRatioY() { return this.allSelection[this.cropRatioYID] },
        cropper() { return getCropper() },
        first() {
            return parseFloat(
                this.customDimension
                    ? this.customDimension.includes("|")
                        ? this.customDimension.split("|")[0].split(",")[0]
                        : this.customDimension.split(",")[0]
                    : 0
            );
        },
        second() {
            return parseFloat(
                this.customDimension
                    ? this.customDimension.includes("|")
                        ? this.customDimension.split("|")[0].split(",")[1]
                        : this.customDimension.split(",")[1]
                    : 0
            );
        },
        customDimensionRatio() { return this.first / this.second },
    },
    methods: {
        updateCropPosition() {
            setTimeout(() => {
                const cropper = getCropper();
                const data = cropper.getData(true)
                this.$store.commit("advancedSetting/setSelection", 
                    { uid: "root", key: this.$store.state.advancedSetting.cropSettingsIds['crop-position-x'], value: Number(data.x).toFixed(0) });
                this.$store.commit("advancedSetting/setSelection", 
                    { uid: "root", key: this.$store.state.advancedSetting.cropSettingsIds['crop-position-y'], value: Number(data.y).toFixed(0) });
            }, 300);
        },
        commitCropChanges({ uid, slug, field, value }) {
            const as = Object.assign({}, JSON.parse(JSON.stringify(this.$store.state.advancedSetting.userData)));
            const allSelection = as.allSelection.root;
            const selection = {};
            selection.crop_aspect_ratio = allSelection[getKeyByValue(as.fieldNames, "crop_aspect_ratio")];
            selection.crop_orientation = allSelection[getKeyByValue(as.fieldNames, "crop_orientation")];
            selection["crop_width,crop_height"] = allSelection[getKeyByValue(as.fieldNames, "crop_width,crop_height")];
            selection[field.name] = value;
            if (selection.crop_aspect_ratio) selection.crop_aspect_ratio = as.fieldNames[selection.crop_aspect_ratio];

            const cropper = getCropper();
            if (cropper) {
                let data = cropper.getData(true)
                const frame = { width: cropper.imageData.naturalWidth, height: cropper.imageData.naturalHeight }
                const oldCropData = { ...data }
                const newCropData = { ...data }
                this.lastOrientation = selection.crop_orientation;
                this.lastCrop_aspect_ratio = selection.crop_aspect_ratio;
                const initialRatioX = Number(this.$store.state.advancedSetting.userData.allSelection.root[this.cropRatioXID])
                const initialRatioY = Number(this.$store.state.advancedSetting.userData.allSelection.root[this.cropRatioYID])
                let cropRatio = initialRatioX / initialRatioY
                let maxDimension
                /**
                 * Handle the aspect ratio
                 */
                if (selection.crop_aspect_ratio) {
                    if (selection.crop_aspect_ratio === "free") cropRatio = 0
                    else if (selection.crop_aspect_ratio === "same") cropRatio = cropper.imageData.naturalWidth / cropper.imageData.naturalHeight
                    else if (selection.crop_aspect_ratio !== 'custom' && this.aspectRatio !== eval(selection.crop_aspect_ratio)) cropRatio = eval(selection.crop_aspect_ratio)
                    if (field.name === 'crop_aspect_ratio') {
                        maxDimension = this.calculateChildBoxDimensions(frame.width, frame.height, cropRatio)
                        newCropData.height = maxDimension.height
                        newCropData.width = maxDimension.width
                    }
                }
                /**
                 * Handle custom aspect ratio
                 */
                if (selection.crop_aspect_ratio === "custom") {
                    if (field.name === 'crop_aspect_ratio') {
                        cropRatio = 1
                        as.allSelection.root[this.cropRatioXID] = 1
                        as.allSelection.root[this.cropRatioYID] = 1
                        maxDimension = this.calculateChildBoxDimensions(frame.width, frame.height, cropRatio)
                        newCropData.height = maxDimension.height
                        newCropData.width = maxDimension.width
                    }
                    if (['crop_ratio_x', 'crop_ratio_y'].includes(field.name) && value > 0) {
                        if (field.name === 'crop_ratio_x') as.allSelection.root[this.cropRatioXID] = value
                        if (field.name === 'crop_ratio_y') as.allSelection.root[this.cropRatioYID] = value
                        cropRatio = this.cropRatioX / this.cropRatioY;
                        maxDimension = this.calculateChildBoxDimensions(frame.width, frame.height, cropRatio)
                        newCropData.height = maxDimension.height
                        newCropData.width = maxDimension.width
                    }
                }
                /**
                 * Handle the crop height and width input
                 */
                if (field.name == 'crop_width,crop_height') {
                    const [userInputtedWidth, userInputtedHeight] = value.split(',')
                    const [oldInputtedHeight, oldInputtedWidth] = [oldCropData.height, oldCropData.width]
                    const activeInput = $nuxt.$store.state.advancedSetting.customDimensionActiveInput
                    
                    if (activeInput === 'height') {
                        newCropData.height = Number(userInputtedHeight)
                        newCropData.width = cropRatio ? Math.round(newCropData.height * cropRatio) : oldInputtedWidth
                    } else {
                        newCropData.width = Number(userInputtedWidth)
                        newCropData.height = cropRatio ? Math.round(newCropData.width / cropRatio) : oldInputtedHeight
                    }
                }
                /**
                 * Handle orientation toggle
                 */
                if (field.name === 'crop_orientation') {
                    const tempData = {...newCropData}
                    const toggledRatio = [as.allSelection.root[this.cropRatioYID], as.allSelection.root[this.cropRatioXID]]

                    cropRatio = tempData.height / tempData.width;

                    maxDimension = this.calculateChildBoxDimensions(frame.width, frame.height, cropRatio)

                    const isOffLimit = (oldCropData.width > frame.height) 
                        ? 'height'
                        : (oldCropData.height > frame.width) 
                            ? 'width'
                            : false

                    if(isOffLimit === 'height') {
                        newCropData.height = frame.height
                        newCropData.width = Math.ceil(frame.height * cropRatio)
                    } else if(isOffLimit === 'width') {
                        newCropData.width = frame.width
                        newCropData.height = Math.ceil(frame.width / cropRatio)
                    } else {
                        newCropData.height = oldCropData.width
                        newCropData.width = oldCropData.height
                    }

                    as.allSelection.root[this.cropRatioXID] = toggledRatio[0]
                    as.allSelection.root[this.cropRatioYID] = toggledRatio[1]
                }
                /**
                 * Setting the cropper with the new crop changes
                 */
                if (selection.crop_aspect_ratio !== "free") cropper.setAspectRatio(cropRatio);
                
                cropper.setData(newCropData, selection.crop_aspect_ratio)
                if(!['crop-position-x' , 'crop-position-y'].includes(field.name)) this.updateCropPosition()
                /** 
                 * Updating the store variables for crop
                 */
                if (selection.crop_aspect_ratio) allSelection[getKeyByValue(as.fieldNames, "crop_aspect_ratio")] = getKeyByValue(as.fieldNames, selection.crop_aspect_ratio);
                allSelection[getKeyByValue(as.fieldNames, "crop_orientation")] = this.lastOrientation;
                if (selection["crop_width,crop_height"]) allSelection[getKeyByValue(as.fieldNames, "crop_width,crop_height")] = `${newCropData.width},${newCropData.height}`;
                if (selection["crop-position-x"]) {
                    allSelection[getKeyByValue(as.fieldNames, "crop-position-x")] = selection["crop-position-x"]
                    newCropData.x = Number(selection["crop-position-x"])
                }
                if (selection["crop-position-y"]) {
                    allSelection[getKeyByValue(as.fieldNames, "crop-position-y")] = selection["crop-position-y"]
                    newCropData.y = Number(selection["crop-position-y"])
                }
                
                as.allSelection.finalSelection = { video_crop: `${newCropData.width}:${newCropData.height}:${newCropData.x}:${newCropData.y}` }
            }
            /**
             * Finally commiting the changes to the store.
             */
            this.$store.commit("advancedSetting/setUserData", as)
        },
        calculateChildBoxDimensions(width, height, ratio) {
            const parentWidth = width * 0.9
            const parentHeight = height * 0.9
            const aspectRatio = parseFloat(ratio);
            let childWidth, childHeight;
            if ((parentWidth / aspectRatio) <= parentHeight) {
                childWidth = parentWidth;
                childHeight = parentWidth / aspectRatio;
            } else {
                childHeight = parentHeight;
                childWidth = parentHeight * aspectRatio;
            }
            return { width: Math.round(childWidth), height: Math.round(childHeight) }
        }
    }
};
